





//  window.addEventListener('load', function () {

//     // console.log("script Loaded");
//     // Button click scroll
    
//     // document.querySelector('[data-title="THE RITUAL"] a').addEventListener('click', () => {
//     //   console.log("Ritual Added")
//     //   event.preventDefault()
//     //   gsap.to(window, {
//     //     duration: 1,
//     //     scrollTo: '#ritual_section',
//     //     ease: 'power2.inOut',
//     //   });
//     // });

//     // document.getElementById('rust_btn').addEventListener('click', () => {
//     //   gsap.to(window, {
//     //     duration: 1,
//     //     scrollTo: '#container-club-id',
//     //     ease: 'power2.inOut',
//     //   });
//     // });

//     // document.querySelector('[data-title="RESERVE SPOT"] a').addEventListener('click', () => {
//     //   console.log("Reserve Spot Added")
//     //   event.preventDefault()
//     //   gsap.to(window, {
//     //     duration: 1,
//     //     scrollTo: '#container-club-id',
//     //     ease: 'power2.inOut',
//     //   });
//     // });

//   });














    console.log('ran1');


function truncateToWords(selector = '.three-words', nWords = 2) {

    console.log('ran3');


  const nodes = document.querySelectorAll(selector);
  nodes.forEach(el => {
    const full = el.textContent.trim();
    if (!full) return;
    // store original
    el.dataset.fulltext = full;
    el.title = full; // accessible tooltip
    // split words by whitespace (keeps punctuation attached to words)
    const parts = full.split(/\s+/);
    if (parts.length <= nWords) {
      // nothing to do
      el.textContent = full;
    } else {
      const truncated = parts.slice(0, nWords).join(' ');
      el.textContent = truncated + '…';
    }
  });
}

// Run on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => truncateToWords('.three-words', 3));
} else {
  truncateToWords('.three-words', 2);
}



